/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface SendingDomainsConfirmDeletionModalArgs {
  readOnly: boolean;
  confirmationText: string;
  hasDynamicIdentities: boolean;
  onConfirm: () => unknown;
  onCancel: () => unknown;
}

export default class SendingDomainsConfirmDeletionModal extends Component<SendingDomainsConfirmDeletionModalArgs> {
  @tracked confirmationText = '';

  get canDeleteDomain() {
    return this.confirmationText === this.args.confirmationText;
  }
}
